import React from 'react';
import {
  Col, Row, FormGroup,
} from 'reactstrap';
import Button from 'components/buttons/Button';
import TagsInput from 'react-tagsinput';
import Select from 'components/forms/Select';
import RenderTag from 'components/forms/RenderTag';
import { compose } from 'redux'; // isn't related to redux, just an awesome utils
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import Error from 'components/forms/Error';

import RenderFormInput from 'components/forms/RenderFormInput';
import { emailValidator, requiredValidator } from 'utils/validators';

const styles = theme => ({
  label: {
    color: theme.palette.secondary.text,
    fontSize: '0.875rem',
    marginTop: '0.875rem',
  },
});

const DetailsForm = (props) => {
  const { classes } = props;
  return (
    <form onSubmit={props.handleSubmit}>
      <Row>
        <Col lg={6} xl={5} className="push-bottom">
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label className={`${classes.label} col-sm-3`} htmlFor="email">Primary Email</label>
            <Col sm={9}>
              <Field
                maxLength="255"
                name="email"
                component={RenderFormInput}
                type="text"
                validate={[emailValidator, requiredValidator]}
              />

            </Col>
          </FormGroup>
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label className={`${classes.label} col-sm-3`} htmlFor="selectedIndustryTags">Industry tags</label>
            <Col sm={9}>
              <Field
                name="selectedIndustryTags"
                id="selectedIndustryTags"
                component={propsCus => (
                  <Select
                    placeholder="tag name"
                    isMulti
                    value={propsCus.input.value || []}
                    onChange={propsCus.input.onChange}
                    onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
                    options={props.industries.options || []}
                  />
                )}
              />
            </Col>
          </FormGroup>

        </Col>

        <Col lg={5} xl={5} className="offset-lg-1">
          <FormGroup row>
            {/* eslint-disable jsx-a11y/label-has-for */}
            <label className={`${classes.label} col-sm-3`} htmlFor="selectedProducts">Products</label>
            <Col sm={9}>
              <Field
                name="selectedProducts"
                component={propsCus => (
                  <React.Fragment>
                    <TagsInput
                      addOnBlur
                      addKeys={['Enter', 'Tab']}
                      className="form-control"
                      inputProps={{
                        className: 'react-tagsinput-input',
                        placeholder: 'Type a product name and press enter.',
                      }}
                      renderTag={RenderTag}
                      value={propsCus.input.value || []}
                      onChange={propsCus.input.onChange}
                      onBlur={() => propsCus.input.onBlur(propsCus.input.value)}
                    />
                    {propsCus.meta.touched &&
                      propsCus.meta.error && <Error error={propsCus.meta.error} />}
                  </React.Fragment>
                )}
              />
            </Col>
          </FormGroup>
        </Col>

      </Row>

      <Button color="secondary" variant="outlined" disabled={props.pristine || props.submitting} type="submit">
        Save
      </Button>
    </form>
  );
};


DetailsForm.propTypes = {
  classes: PropTypes.element.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  industries: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })),
  }).isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};


DetailsForm.defaultProps = {
  submitting: false,
  pristine: true,
};

export default compose(
  withStyles(styles),
  connect(
    state => ({
      industries: state.industries,
      initialValues: {
        acceptsSponsorships: state.account.accepts_sponsorships,
        email: state.account.email,
        selectedProducts: state.account.products.map(product => product.name),
        selectedIndustryTags: state.industries.options.filter(obj => state.account.industries.includes(obj.value)),
      },
    }),
    { },
  ),
  reduxForm({
    form: 'accountDetailsForm',
    enableReinitialize: true,
  }),
)(DetailsForm);
